import { render, staticRenderFns } from "./checkoutInfo.vue?vue&type=template&id=61550508&scoped=true&"
import script from "./checkoutInfo.vue?vue&type=script&lang=js&"
export * from "./checkoutInfo.vue?vue&type=script&lang=js&"
import style0 from "./checkoutInfo.vue?vue&type=style&index=0&id=61550508&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61550508",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
